import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SiteService } from "@services/site.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "goodsMenu",
	styleUrls: ["goodsMenu.css"],
	templateUrl: "goodsMenu.html"
})
export class GoodsMenuComponent {
	dateTime = new Date;
	isLoading = false;
	mode = "";
	showPopup = false;
	site = "";
	siteId = 0;

	constructor(private route: ActivatedRoute, private toastService: ToastService, private router: Router, private siteService: SiteService) {
		this.route.params
			.subscribe(async (params) => {
				this.mode = params.mode;
				this.siteId = Number.parseInt(params.id);
			});
		this.setSite(this.siteId);
	}

	navigateToInternal() {
		const implemented = false;
		if (implemented) {
			if (this.mode.toLowerCase() == "in") {
				this.router.navigate([`admin/webapps/goodsDetail/${this.siteId}/3`]);
			} else {
				this.router.navigate([`admin/webapps/goodsDetail/${this.siteId}/6`]);
			}
		} else {
			alert("Not yet implemented!");
		}

	}

	navigateToOutsourced(id: number) {
		if(id == 4){
			this.router.navigate([`admin/webapps/outside/${this.siteId}/1`]);
		} else {
			this.router.navigate([`admin/webapps/outside/${this.siteId}/0`]);
		}

	}

	navigateToPage(id: number) {
		if (id !== 5) {
			this.router.navigate([`admin/webapps/goodsDetail/${this.siteId}/${id}`]);
		} else {
			alert("Not yet implemented!");
		}

	}

	navigateToRelocateStock() {
		this.router.navigate(["admin/webapps/moveStock"]);
	}

	navigateToStockControl(direction: number) {
		this.router.navigate([`admin/webapps/stockControl/${direction}`]);
	}

	async setSite(id: number) {
		switch (id) {
			case 1:
				this.site = "KINGS NORTON";
				return;
			case 2:
				this.site = "SELLY OAK";
				return;
			case 3:
				this.site = "REDDITCH";
				return;
			case 5:
				this.site = "REDDITCH TOOLROOM";
				return;
			default:
				this.site = "KINGS NORTON";
				return;
		}
	}

	switchMode() {
		if (this.mode.toLowerCase() == "in") {
			this.router.navigate([`admin/webapps/goods/${this.siteId}/out`]);
		} else {
			this.router.navigate([`admin/webapps/goods/${this.siteId}/in`]);
		}

	}
}